import { t } from "@lingui/macro"
import { Stack, TextField } from "@mui/material"
import { observer } from "mobx-react"

import { formFields } from "src/modals/knowledge-items/formFields"
import { KnowledgeItemStore } from "src/modals/knowledge-items/store"
import { useStore } from "src/store/lib/useStore"
import { WysiwygEditor } from "src/components/WysiwygEditor"

export const KnowledgeItemsContentSection = observer(() => {
    const store = useStore(KnowledgeItemStore)

    return (
        <Stack spacing={2}>
            <TextField
                label={t`knowledge-item-modal.internal-name`}
                onChange={store.formFields.setter("title")}
                value={store.formFields.get("title") ?? ""}
                helperText={
                    store.formFields.error("title") ??
                    t`knowledge-item-modal.internal-name-helper`
                }
                error={Boolean(store.formFields.error("title"))}
                disabled={store.formFields.get("access_type") === "READ"}
                inputProps={{ maxLength: 40 }}
            />
            {store.formFields.get("knowledge_item_type") === "file" && (
                <formFields.KnowledgeItemsFile />
            )}
            {store.formFields.get("knowledge_item_type") === "page" && (
                <WysiwygEditor
                    initialValue={
                        (store.formFields.get("content") as string) ?? ""
                    }
                    onChange={(value) => store.formFields.set("content", value)}
                    invalid={Boolean(store.formFields.error("content"))}
                    readOnly={store.formFields.get("access_type") === "READ"}
                    placeholder={t`knowledge-item-modal.page-placeholder`}
                    sx={{
                        "& .wysiwyg-editor__wrapper": {
                            minHeight: "200px",
                            "& .wysiwyg-editor__editor": {
                                minHeight: "150px",
                                maxHeight: "400px",
                                overflowY: "auto",
                            },
                        },
                    }}
                />
            )}
            {store.formFields.get("knowledge_item_type") === "web" && (
                <formFields.KnowledgeItemsWebSearch />
            )}
        </Stack>
    )
})
